import React, { useEffect, useState } from "react";
import FormInput from "./FormInput";
import DragAndDropGrid from "./DragAndDropGrid";
import Modal from "./Modal";

function BuckForm({ isMobile, style, onSubmit, onCancel, handleChange, formData, formDataErrors, formError, newBuck, changesMade, submitted, images, handleImageChange }) {
    const [items, setItems] = useState(null);
    const [showModal, setShowModal] = useState(false);

    useEffect(() => {
        if(images) {
            let dragAndDropObjects = images.map((image, index) => {
                return({
                    'id': `${index + 1}`,
                    'element': <img style={{ "width": "100%" }} src={image} alt={`${image.split("://")[1].split("/")[2].split("?")[0]}`} />
                });
            });

            setItems(dragAndDropObjects);
        }
    }, [images]);

    const handleItemChange = (e) => {
        let newImages = e.map((item) => {
            return(item.element.props.src)
        });

        handleImageChange(newImages);
    };

    return (
        <div className="form-container" style={isMobile ? { ...style, "marginTop": "16px" } : { "display": "flex", ...style }}>
            <form 
                onSubmit={async (e) => { 
                    e.preventDefault();
                    onSubmit();
                }}
            >
                <div className="form-group">
                    <label htmlFor="name">Name</label>
                    <FormInput disabled={!newBuck || submitted} isMobile={isMobile} updateParent={handleChange} placeholder="Enter name" name="name" type="text" object={formData} errors={formDataErrors} reaction={{ "border": "1px solid #ccc" }} />
                </div>
                {newBuck ? (
                    <div style={{ "display": "flex", "marginBottom": "15px" }}>
                        <label style={{ "width": "100%", "margin": "0px", "display": "block", "fontWeight": "bold" }}>Multiple Bucks In Image</label>
                        <FormInput disabled={submitted} isMobile={isMobile} updateParent={handleChange} name="multipleBucksInImage" type="checkbox" object={formData} errors={formDataErrors} />
                    </div>
                ) : null}
                <div className="form-group">
                    <label htmlFor="age">Age</label>
                    <FormInput disabled={submitted} isMobile={isMobile} updateParent={handleChange} placeholder="Enter age" name="age" type="number" object={formData} errors={formDataErrors} reaction={{ "border": "1px solid #ccc" }} />
                </div>
                <div className="form-group">
                    <label htmlFor="points">Points</label>
                    <FormInput disabled={submitted} isMobile={isMobile} updateParent={handleChange} placeholder="Enter points" step="1" name="points" type="number" object={formData} errors={formDataErrors} reaction={{ "border": "1px solid #ccc" }} />
                </div>
                <div className="form-group">
                    <label htmlFor="classification">Classification</label>
                    <FormInput disabled={submitted} isMobile={isMobile} dropDownOptions={["Protect", "Trophy", "Management"]} updateParent={handleChange} placeholder="Select a Classification" name="classification" type="dropdown" object={formData} errors={formDataErrors} reaction={{ "border": "1px solid #ccc" }} />
                </div>
                <div className="form-group">
                    <label htmlFor="notes">Public Notes (Visible to Everyone)</label>
                    <FormInput disabled={submitted} isMobile={isMobile} updateParent={handleChange} placeholder="Enter Public Notes" name="notes" type="textArea" object={formData} errors={formDataErrors} reaction={{ "border": "1px solid #ccc", "minWidth": "295px", "maxWidth": "800px" }} />
                </div>
                <div className="form-group">
                    <label htmlFor="privateNotes">Private Notes</label>
                    <FormInput disabled={submitted} isMobile={isMobile} updateParent={handleChange} placeholder="Enter Private Notes" name="privateNotes" type="textArea" object={formData} errors={formDataErrors} reaction={{ "border": "1px solid #ccc", "minWidth": "295px", "maxWidth": "800px" }} />
                </div>
                <div style={{ "display": "flex", "marginBottom": "15px" }}>
                    <label style={{ "width": "100%", "margin": "0px", "display": "block", "fontWeight": "bold" }}>Publish to Buck Inventory</label>
                    <FormInput disabled={submitted} isMobile={isMobile} updateParent={handleChange} name="published" type="checkbox" object={formData} errors={formDataErrors} />
                </div>
                {newBuck && formData && formData.hasOwnProperty("multipleBucksInImage") && formData.multipleBucksInImage ? (
                    <div style={{ "display": "flex", "marginBottom": "15px" }}>
                        <label style={{ "width": "100%", "margin": "0px", "display": "block", "fontWeight": "bold" }}>All Unique Bucks Labeled</label>
                        <FormInput disabled={submitted} isMobile={isMobile} updateParent={handleChange} name="allDeerLabeled" type="checkbox" object={formData} errors={formDataErrors} />
                    </div>
                ) : null}
                {isMobile && items ? (
                    <div style={{ "marginLeft": "32px" }}>
                        <DragAndDropGrid items={items} handleItemChange={handleImageChange} maximumHeight={300} />
                    </div>
                ) : null}
                <div style={{ "display": "flex" }}>
                    {newBuck ? (
                        <button disabled={submitted || !changesMade} className="main-button" style={{ "marginRight": "16px" }} type="submit">Save New Buck</button>
                    ) : (
                        <button disabled={submitted || !changesMade} className="main-button" style={{ "marginRight": "16px" }} type="submit">Save Updated Buck</button>
                    )}
                    <button disabled={submitted} className="main-button" onClick={(e) => { e.preventDefault(); onCancel(); }}>Cancel</button>
                </div>
                <div className="form-error">{formError}</div>
            </form>
            {!isMobile && items ? (
                <div style={{ "marginLeft": "32px" }}>
                    <DragAndDropGrid items={items} handleItemChange={handleItemChange} onDoubleClick={setShowModal} />
                </div>
            ) : null}
            {items && typeof showModal === "number" ? (
                <Modal closeButton={true} onClose={() => setShowModal(null)} >
                    <img src={items[showModal]} alt={`${formData.name} ${showModal + 1}`} />
                </Modal>
            ) : null}

        </div>
    );
};

export default BuckForm;